var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgConnect16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41421 8.00001L10.8284 9.41422L15.0711 5.17158L10.8284 0.92894L6.58578 5.17158L8 6.58579L6.58579 8L5.17157 6.58578L0.928932 10.8284L5.17157 15.0711L9.41421 10.8284L8 9.41421L9.41421 8.00001ZM12.2426 5.17158L10.8284 3.75737L9.41421 5.17158L10.8284 6.58579L12.2426 5.17158ZM6.58579 10.8284L5.17157 9.41421L3.75736 10.8284L5.17157 12.2426L6.58579 10.8284Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnect16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;